import { RequestServerClass } from '../../util/request';
import publishObjectPath from '@/util/configRegistry';

const serverUrl = publishObjectPath.serverUrl;

export class DictServe {
  public rSerivce: any;

  constructor(opt: any, axiosFilterFn?: any) {
    this.rSerivce = new RequestServerClass(opt);
    axiosFilterFn.call(this, this.rSerivce.serverObj);
  }

  // 分页查询所有字典数据
  public sysDictList(opts: object) {
    const url = serverUrl + '/api/sysManage/sysDict';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 通过主键查询单条数据
  public getSingleDictData(id: any) {
    const url = serverUrl + `/api/sysManage/sysDict/${id}`;
    return this.rSerivce.serverObj.get(url);
  }

  // 新增数据
  public addDictData(opts: object) {
    const url = serverUrl + '/api/sysManage/sysDict';
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 修改数据
  public editDictData(opts: object) {
    const url = serverUrl + '/api/sysManage/sysDict';
    return this.rSerivce.serverObj.put(url, opts);
  }

  // 删除字典管理数据
  public deleteDictData(id: any) {
    const url = serverUrl + '/api/sysManage/sysDict?idList=' + id;
    return this.rSerivce.serverObj.delete(url);
  }

  // 查询所有字典详情数据
  public sysDictTypeList(opts: object) {
    const url = serverUrl + '/api/sysManage/sysDictDetail/all';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 删除字典管理详情表格数据
  public deleteDictTypeData(id: any) {
    const url = serverUrl + '/api/sysManage/sysDictDetail?idList=' + id;
    return this.rSerivce.serverObj.delete(url);
  }

  // 通过主键查询字典数据的单条数据
  public getSingleDictTypeData(id: any) {
    const url = serverUrl + `/api/sysManage/sysDictDetail/${id}`;
    return this.rSerivce.serverObj.get(url);
  }

  // 新增数据
  public addDictTypeData(opts: object) {
    const url = serverUrl + '/api/sysManage/sysDictDetail';
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 修改数据
  public editDictTypeData(opts: object) {
    const url = serverUrl + '/api/sysManage/sysDictDetail';
    return this.rSerivce.serverObj.put(url, opts);
  }

  // 查询所有字典详情数据
  public getAllDictTypeList(opts: object) {
    const url = serverUrl + '/api/sysManage/sysDict/all';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
  // 根据字典name获取详情map（value、label）
  public getDetailsMapByName(type: any) {
    const url = serverUrl + '/api/sysManage/sysDict/getDetailsMapByName';
    return this.rSerivce.serverObj.get(url, {
      params: {
        name: type,
      },
    });
  }
}
